"use client";

import type { ReactNode } from "react";
import { Search } from "@/components/icons";
import { useSearchContextSafe } from "./search-context";
import { cn } from "@/lib/utils";
import {
  HIDDEN_BESIDE_HERO_ASK,
  HIDDEN_BESIDE_LISTING_SEARCH,
} from "@/components/layout/hero-ask-visibility";
import { Button } from "@/components/ui/button";
import { IconButton } from "@/components/ui/icon-button";

interface PublicSearchTriggerProps {
  className?: string;
  placeholder?: string;
}

function OpenSearchForm({ children }: { children: ReactNode }) {
  const { openSearch } = useSearchContextSafe();
  return (
    <form action={openSearch} className="contents">
      {children}
    </form>
  );
}

export function PublicSearchTrigger({
  className,
  placeholder = "Search packaging",
}: PublicSearchTriggerProps) {
  return (
    <div
      className={cn(
        "flex h-10 items-center rounded-full border border-border bg-surface px-1 transition-colors hover:border-fg-muted focus-within:ring-2 focus-within:ring-ring",
        className,
      )}
    >
      <OpenSearchForm>
        <Button type="submit" variant="field" size="default" className="min-w-0 flex-1">
          <Search />
          <span className="flex-1 truncate text-left">{placeholder}</span>
        </Button>
      </OpenSearchForm>
    </div>
  );
}

export function PublicSearchIconTrigger({ className }: { className?: string }) {
  return (
    <OpenSearchForm>
      <IconButton
        type="submit"
        size="compact"
        className={cn("rounded-full text-muted-foreground", className)}
        aria-label="Search"
      >
        <Search />
      </IconButton>
    </OpenSearchForm>
  );
}

export function PublicHeaderSearchTriggers() {
  return (
    <>
      <div className={cn("hidden w-full max-w-md min-[1360px]:block [:root[data-ask-panel=open]_&]:hidden", HIDDEN_BESIDE_HERO_ASK, HIDDEN_BESIDE_LISTING_SEARCH)}>
        <PublicSearchTrigger className="w-full" />
      </div>
      <div className={cn("block min-[1360px]:hidden [:root[data-ask-panel=open]_&]:hidden", HIDDEN_BESIDE_HERO_ASK, HIDDEN_BESIDE_LISTING_SEARCH)}>
        <PublicSearchIconTrigger />
      </div>
    </>
  );
}
